import { AccessLevel } from '@bimdata/definitions/const';
import t from '@/utils/translate';

export default function (l: AccessLevel) {
  switch (l) {
    case AccessLevel.READER: return t('project.access.read');
    case AccessLevel.WRITER: return t('project.access.write');
    case AccessLevel.ADMIN: return t('project.access.admin');
    case AccessLevel.OWNER: return t('project.access.owner');
  }
};